<template>
    <card-seplag :titulo="'Formação acadêmica'" cor="#00acc1">
        <div class="p-col-12 avisos">
            <div>
                <b>Cursos de Formação: </b>referem-se aos cursos de educação formal que traz como resultado uma formação, que se referem aos cursos de:
                <b>Nível Médio Técnico, Tecnólogo, Graduação, Especialização, Residência, Mba, Mestrado, Doutorado e Pós-doutorado.</b>
            </div>
            <div>
                Serão incluídos na etapa seguinte os <b>cursos de capacitação</b>  que se referem a participação em 
                <b>Congresso, curso, estágio profissional, eventos artísticos, eventos científicos, eventos culturais, eventos educacionais, Fórum, Intercâmbio, Palestra, Seminário, Simpósio, Treinamento em serviço, Oficina/Workshop.</b>
            </div>
            
        </div>
        <card-seplag :titulo="'Formações cadastradas'" class="p-col-12 ajusteSecao" cor="#00acc1">
            <div class="p-col-12 ajusteSecao">
                <div v-if="arrayRegistro && arrayRegistro.length > 0" class="p-col-12">
                    <button  v-for="(formacao, index) in arrayRegistro" :key="formacao.idenFormacaoAcademica" type="button" @click="funcaoAccord(index)" class="p-col-12 ajustePanel">
                    <Panel :toggleable="true" :collapsed="controlePanel[index]" class="p-col-12 ajustePanel" >
                        <template slot="header">
                            <span class="acordion">{{colapseTeste}}</span>
                            <span>{{index + 1 + ' - ' + formacao.descCurso }}
                                <span v-if="formacao.statFormacaoAcademica=='REJEITADO'" class="statusVinculoIrregular alinhamentoNome">Rejeitado</span>
                                <span v-if="formacao.statFormacaoAcademica=='PENDENTE'" class="statusVinculoPendente alinhamentoNome">Pendente</span>
                                <span v-if="formacao.statFormacaoAcademica=='PENDENTE_VALIDACAO'" class="statusVinculoPendente alinhamentoNome">AGUARDANDO VALIDAÇÃO</span>
                                <span v-if="formacao.statFormacaoAcademica=='CONCLUIDO'" class="statusVinculoConcluido alinhamentoNome">Concluído</span>
                                <span v-if="formacao.statFormacaoAcademica=='VALIDADO'" class="statusVinculoConcluido alinhamentoNome">Validado</span>
                            </span>                       
                            <span class="acordion">{{isCollapsed}}</span>
                        </template>
                        <div class="p-grid p-fluid">
                            <div class="p-col-12 ajusteContent" v-if="formacao.nivelFormacao">
                                <label><strong>Nível de formação:
                                    </strong>{{ formacao.nivelFormacao.nomeNivelFormacao }}</label>
                            </div>
                            <div class="p-col-12 ajusteContent" v-if="formacao.areaFormacao">
                                <label><strong>Área de formação: </strong>{{ formacao.areaFormacao.descAreaFormacao
                                }}</label>
                            </div>
                            <div class="p-col-12 ajusteContent">
                                <label><strong>Modalidade: </strong>{{ formacao.modalidadeEnsino ?
                                        formacao.modalidadeEnsino.nomeModalidade : "Não Informado"
                                }}</label>
                            </div>
                            <div class="p-col-12 ajusteContent" v-if="formacao.descInstituicao">
                                <label><strong>Instituição: </strong>{{ formacao.descInstituicao }}</label>
                            </div>
                            <div class="p-col-12 p-md-12 ajusteContent" v-if="formacao.dataConclusao">
                                <label><strong>Data da conclusão: </strong>{{ formacao.dataConclusao }}</label>
                            </div>
                          
                        </div>
                    </Panel>
                </button>
                </div>
                <span v-else><i>Nenhum registro encontrado</i></span>
                
            </div>
        </card-seplag>

        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12 p-md-2 p-md-offset-3">
                    <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />
                </div>
                <div class="p-col-12 p-md-2">
                    <Button label="Próximo" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
                </div>
            </div>
        </div>

    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import {baseApiUrl} from '@/config/global'

const getDefaultFormacaoAcademica = () => {
    return {
        nivelFormacao: null,
        areaFormacao: null,
        descCurso: null,
        descInstituicao: null,
        formacaoContinuada: null,
        modalidadeEnsino: null,
        dataConclusao: ''
    }
}
export default {
    name: "FormacaoAcademica",
    components: { CardSeplag },
    data() {
        return {
            registro: getDefaultFormacaoAcademica(),
            registroAnterior: null,
            arrayRegistro: [],
            contadorID: 0,
            formacaoContinuada: [],
            modalidade: [],
            areaformacoes: [],
            nivelFormacao: [],
            controleAccord: [],
            flagEdicao: false,
            camposPreenchidos: false,
            exibirDialogoDeletar: false,
            exibirNovaFormacao: false,
            cursos: [],
            cursosSelecionados: [],
            cursosSelecionado: null,
            listaCursos: [],
            resultadoBusca: null,
            teste: null,
            isCollapsed: false,
            colapseTeste:[],
            controlePanel: []

        }
    },
    methods: {
        async carregarDados() {
            if (this.$store.getters.getDadosPessoa) {

                this.formacaoContinuada = this.$store.getters.getFormacaoContinuadas
                this.modalidades = this.$store.getters.getModalidades
                // this.areaformacoes = this.$store.getters.getAreaFormacoes
                this.$http.get(`${baseApiUrl}/modalidades/ativos`).then(res =>{
                    this.modalidades = res.data
                })
                this.$http.get(`${baseApiUrl}/areaformacoes/flagRecad`).then(res =>{
                    this.areaformacoes = res.data
                })

                 this.$http.get(`${baseApiUrl}/formacaoacademicas/ciclopessoa/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res => {
                    this.arrayRegistro = res.data
                    for (let i = 0; i < this.arrayRegistro.length; i++) {
                        this.controlePanel[i] = true
                        this.colapseTeste[i] = false
                    }
                })

                this.$http.get(`${baseApiUrl}/nivelformacoes/recadastramento/all`).then(res => {
                    this.nivelFormacao = res.data
                })

                this.$http.get(`${baseApiUrl}/areaformacoes/flagRecad`).then(res => {
                    this.cursos = res.data
                    this.cursos.forEach(item => {
                        if (item) {
                            this.listaCursos.push(this.especialCharMask(item.descAreaFormacao))
                        }
                    })
                    this.cursos = this.listaCursos
                })

            } else {
                this.$router.push({ name: "recadastramento" })
            }
        },
        nextPage() {
            this.$router.push({ name: 'RECADVIEW_CAPACITACAO_VIEW' })
        },
        prevPage() {
            this.$router.push({ name: 'RECADVIEW_ENDERECO_VIEW' })
        },

        especialCharMask(str) {

            str = str.replace(/[àáâãäå]/g, "a");
            str = str.replace(/[ÀÁÂÃÄÅ]/g, "A");

            str = str.replace(/[éèêë]/g, "e");
            str = str.replace(/[ÉÈÊË]/g, "E");

            str = str.replace(/[íìîï]/g, "i");
            str = str.replace(/[ÍÌÎÏ]/g, "I");

            str = str.replace(/[óòõôö]/g, "o");
            str = str.replace(/[ÓÒÕÔÖ]/g, "O");

            str = str.replace(/[úùûü]/g, "u");
            str = str.replace(/[ÚÙÛÜ]/g, "U");

            str = str.replace(/[ç]/g, "c");
            str = str.replace(/[Ç]/g, "C");
            
            str = str.replace(/[!@#$%¬&*=+/?|°ºª§´^~¨()_"]/g, "");  

            return str;
        },
        funcaoAccord(index) {
            this.controlePanel[index] = this.isCollapsed
            this.isCollapsed = !this.isCollapsed 
            this.controlePanel[index] =  this.colapseTeste[index] 
            this.colapseTeste[index] = !this.colapseTeste[index]
        },
    },


    mounted() {
        this.carregarDados()
    }

}
</script>

<style>
.docConcluido {
    color: #43a047;
    margin-top: 2px;
    margin-left: 15px;
}
.docPendente {
    color: #f2bf27;
    margin-top: 2px;
    margin-left: 15px;
}
.statusVinculoPendente{
    color: #f2bf27;
    margin-right: 3px;
}
.statusVinculoIrregular{
    color: #f27777;
    margin-right: 3px;
}
.statusVinculoConcluido{
    color: #43a047;
    margin-right: 3px;
}
.divcontainerButton {
    margin-top: 1rem;
    width: 100%;
}

.divButton {
    width: 10% !important;
}

.pendenteEdicao {
    color: orange;
}

.ajusteSecao {
    margin-top: 20px;
}

.ajustaBotao {
    /* justify-items: ; */
    justify-content: space-between;
    margin-top: 20px;
}

.ajustePanel {
    margin-top: -15px;
}
.ajusteContent{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start !important;
    justify-items: flex-start;
    margin-right: 1500px;
}

.acordion {
    display: none;
}

AutoComplete {
    text-transform: uppercase;
}
</style>